import { axios } from '@Root/API'

export const getAllSubmissions = id => {
  return axios.get(`cognito-submissions`, { params: { cognito_form_id: id } })
}
